import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (requiredRole && !user?.roles?.includes(requiredRole)) return <Navigate to="/dashboard" replace />;
  if (!requiredRole && user?.roles?.includes('EMPLOYEE')) return <Navigate to="/mi-portal" replace />;

  return <>{children}</>;
};

export default ProtectedRoute;
